import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, Home, FileText } from 'lucide-react';

const LeadSubmittedPage = () => {
  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center" data-testid="lead-submitted-page">
      <Card className="max-w-2xl w-full mx-4">
        <CardContent className="py-16 text-center">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6"><CheckCircle className="h-16 w-16 text-green-600" /></div>
          <h1 className="text-4xl font-bold font-heading text-secondary-900 mb-4">Thank You!</h1>
          <p className="text-xl text-secondary-700 mb-2">Your enquiry has been submitted successfully.</p>
          <p className="text-base text-secondary-600 mb-8">Our team will contact you within 24 hours.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/"><Button size="lg" data-testid="home-button"><Home className="mr-2 h-5 w-5" />Back to Home</Button></Link>
            <Link to="/policies"><Button size="lg" variant="outline" data-testid="browse-policies-button"><FileText className="mr-2 h-5 w-5" />Browse Policies</Button></Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LeadSubmittedPage;
